// D:\Sanad-Ins\sanad-ins\src\redux\slices\languageSlice.js
import { createSlice } from '@reduxjs/toolkit';

// جلب اللغة المخزنة محلياً أو استخدام الإنجليزية كافتراضي
const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  
  const savedLanguage = localStorage.getItem('sanad_language');
  return savedLanguage || 'en';
};

const getInitialDirection = () => {
  return getInitialLanguage() === 'ar' ? 'rtl' : 'ltr';
};

const initialState = {
  currentLanguage: getInitialLanguage(),
  direction: getInitialDirection(),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    toggleLanguage: (state) => {
      const newLanguage = state.currentLanguage === 'en' ? 'ar' : 'en';
      const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
      // تحديث الحالة مباشرة بدون async/await
      state.currentLanguage = newLanguage;
      state.direction = newDirection;
      
      // حفظ في localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem('sanad_language', newLanguage);
      }
      
      // تحديث HTML document
      if (typeof window !== 'undefined') {
        document.documentElement.dir = newDirection;
        document.documentElement.lang = newLanguage;
      }
    },
    setLanguage: (state, action) => {
      const newLanguage = action.payload;
      const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
      state.currentLanguage = newLanguage;
      state.direction = newDirection;
      
      if (typeof window !== 'undefined') {
        localStorage.setItem('sanad_language', newLanguage);
        document.documentElement.dir = newDirection;
        document.documentElement.lang = newLanguage;
      }
    },
    initializeLanguage: (state) => {
      // هذه الدالة يمكن أن تكون فارغة أو تقوم بالتحديث مرة واحدة
      const savedLanguage = getInitialLanguage();
      const direction = savedLanguage === 'ar' ? 'rtl' : 'ltr';
      
      state.currentLanguage = savedLanguage;
      state.direction = direction;
    }
  },
});

export const { toggleLanguage, setLanguage, initializeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
// import { createSlice } from '@reduxjs/toolkit';

// // جلب اللغة المخزنة محلياً أو استخدام الإنجليزية كافتراضي
// const getInitialLanguage = () => {
//   const savedLanguage = localStorage.getItem('sanad_language');
//   if (savedLanguage) {
//     return savedLanguage;
//   }
//   return 'en'; // الإنجليزية هي الافتراضية
// };

// const getInitialDirection = () => {
//   const savedLanguage = localStorage.getItem('sanad_language');
//   if (savedLanguage === 'ar') {
//     return 'rtl';
//   }
//   return 'ltr';
// };

// const languageSlice = createSlice({
//   name: 'language',
//   initialState: {
//     currentLanguage: getInitialLanguage(),
//     direction: getInitialDirection(),
//         isChanging: false

//   },
//   reducers: {
//     toggleLanguage: (state) => {
//       state.isChanging = true;
//       const newLanguage = state.currentLanguage === 'en' ? 'ar' : 'en';
//       const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
//       // تحديث الحالة
//       state.currentLanguage = newLanguage;
//       state.direction = newDirection;
      
//       // حفظ في localStorage
//       localStorage.setItem('sanad_language', newLanguage);
      
//       // تحديث HTML document
//       document.documentElement.dir = newDirection;
//       document.documentElement.lang = newLanguage;
//         setTimeout(() => {
//         state.isChanging = false;
//       }, 500);
//     },
    
//     setLanguage: (state, action) => {
//       const newLanguage = action.payload;
//       const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
//       // تحديث الحالة
//       state.currentLanguage = newLanguage;
//       state.direction = newDirection;
      
//       // حفظ في localStorage
//       localStorage.setItem('sanad_language', newLanguage);
      
//       // تحديث HTML document
//       document.documentElement.dir = newDirection;
//       document.documentElement.lang = newLanguage;
//     },
//     initializeLanguage: (state) => {
//       // تهيئة اللغة من localStorage
//       const savedLanguage = localStorage.getItem('sanad_language') || 'en';
//       const direction = savedLanguage === 'ar' ? 'rtl' : 'ltr';
      
//       state.currentLanguage = savedLanguage;
//       state.direction = direction;
      
//       document.documentElement.dir = direction;
//       document.documentElement.lang = savedLanguage;
//     }
//   },
// });

// export const { toggleLanguage, setLanguage, initializeLanguage } = languageSlice.actions;
// export default languageSlice.reducer;



// // import { createSlice } from '@reduxjs/toolkit';

// // const languageSlice = createSlice({
// //   name: 'language',
// //   initialState: {
// //     currentLanguage: 'en', // الإنجليزية هي الافتراضية
// //     direction: 'ltr',
// //   },
// //   reducers: {
// //     toggleLanguage: (state) => {
// //       state.currentLanguage = state.currentLanguage === 'en' ? 'ar' : 'en';
// //       state.direction = state.currentLanguage === 'ar' ? 'rtl' : 'ltr';
// //       document.documentElement.dir = state.direction;
// //       document.documentElement.lang = state.currentLanguage;
// //     },
// //     setLanguage: (state, action) => {
// //       state.currentLanguage = action.payload;
// //       state.direction = action.payload === 'ar' ? 'rtl' : 'ltr';
// //       document.documentElement.dir = state.direction;
// //       document.documentElement.lang = state.currentLanguage;
// //     },
// //   },
// // });

// // export const { toggleLanguage, setLanguage } = languageSlice.actions;
// // export default languageSlice.reducer;